// removed by extract-text-webpack-plugin
module.exports = {"payment-modal":"payment-modal","stripe-cardnumber":"stripe-cardnumber","email-error":"email-error","price-on-modal":"price-on-modal","secure-msg":"secure-msg","pay-btn":"pay-btn","payment-wrapper":"payment-wrapper","tabs":"tabs","tab":"tab","selected":"selected","payment-info":"payment-info","info-text":"info-text","card-section":"card-section","email-section":"email-section","dollar":"dollar"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/SubscriptionPayment/PaymentModal.scss
// module id = GQeB
// module chunks = 0